// Copyright (c) 2017 Deere & Company

import './index.scss';
import {FormattedMessage} from 'react-intl';
import {Link} from 'react-router';
import React from 'react';

const ProductsByCustomerLinkPanel = () =>
    <div className='products-by-customer-link-panel'>
        <div className='title'>
            <FormattedMessage id='CUSTOMER_DETAILS'/>
        </div>
        <Link to='/products/products-by-customer'>
            <FormattedMessage id='PRODUCTS'/>
        </Link>
    </div>;

ProductsByCustomerLinkPanel.displayName = 'ProductsByCustomerLinkPanel';

export default ProductsByCustomerLinkPanel;



// WEBPACK FOOTER //
// ./src/product/shared/components/products-by-customer-link-panel/index.js